import { MolsonChip } from '@components/reusable'
import type { SxProps } from '@mui/material'
import { type molsonTheme } from '@theme'
import { molsonUseTheme } from '@theme/customMuiExports'

export const OriginalInfoChip = ({
  customSx,
  label
}: {
  customSx?: SxProps<typeof molsonTheme>
  label: string
}) => {
  const theme = molsonUseTheme()
  return (
    <MolsonChip
      sx={{
        '& > span': {
          paddingInline: 1
        },
        borderRadius: 2,
        color: theme.palette.secondary[50],
        fontSize: 12,
        fontWeight: 600,
        height: 25,
        marginLeft: 'auto',
        ...customSx
      }}
      color="primary"
      label={label}
    />
  )
}
